import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { getProductsApi } from "../../utils/guest/api";


function ProductList() {
const [items, setItems] = useState([]);
const [page, setPage] = useState(1);
const [hasMore, setHasMore] = useState(true);

const loadData = async () => {
const result = await getProductsApi(page, 20);

if (!result) return;

const newProducts = result.products;
const totalPages = result.pagination.totalPages;

setItems(prev => [...prev, ...newProducts]);

if (page >= totalPages) {
setHasMore(false);
} else {
setPage(prev => prev + 1);
}
};

useEffect(() => {
loadData();
}, []);

return (
<InfiniteScroll dataLength={items.length} next={loadData} hasMore={hasMore} loader={<p className="text-center py-4">
    Loading...</p>}
    endMessage={<p className="text-center py-4">No more products</p>}
    >
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 p-3">
        {items.map(product => (
        <div key={product._id} className="border p-3 rounded">
            <p className="font-semibold">{product.name}</p>
            <p className="text-sm">₹ {product.price}</p>
        </div>
        ))}
    </div>
</InfiniteScroll>
);
}

export default ProductList;
